'use client'

import { Button, SIDEBAR_WIDTH, useSidebar } from '@repo/ui/components'
import { cn } from '@repo/ui/lib/utils'
import { ChevronLeftIcon, ChevronRightIcon } from 'lucide-react'
import { useMemo } from 'react'

interface IToggleButtonProps {
  sidebarWidth?: string
  type: 'admin' | 'client'
}

export const SideBarToggleButton = ({ sidebarWidth, type }: IToggleButtonProps) => {
  const { isMobile, open, setOpen } = useSidebar()

  const icon = useMemo(
    () =>
      open ? (
        <ChevronLeftIcon className={'stroke-white'} size={20} />
      ) : (
        <ChevronRightIcon className={'stroke-white'} size={20} />
      ),
    [open],
  )

  return (
    !isMobile && (
      <Button
        aria-label="open or close"
        className={cn(
          'absolute top-3 z-[100]',
          'h-5 w-5',
          '-translate-y-1/3 transform transition-all duration-300',
          'p-0',
          type === 'admin' && 'bg-gray-200 hover:bg-gray-300 focus:bg-gray-200 active:bg-gray-200',
          type === 'client' &&
            'bg-[#3B3B3B] hover:bg-[#292929] focus:bg-[#3B3B3B] active:bg-[#3B3B3B]',
        )}
        onClick={() => setOpen(!open)}
        style={{
          left: open ? `calc(${sidebarWidth ?? SIDEBAR_WIDTH} - 28px)` : `36px`,
        }}
      >
        {icon}
      </Button>
    )
  )
}
